import { CSSProperties } from 'styled-components';
import Loading from '../Loading';

interface LoadingPageProps {
  style?: CSSProperties;
  className?: string;
}

const LoadingPage = ({ style, className }: LoadingPageProps) => (
  <div
    className={`w-100 h-100 p-4 overlay d-flex flex-column ${className ?? ''}`}
    style={{ minHeight: '100vh', ...style }}
  >
    <Loading />
  </div>
);

export default LoadingPage;
